const ideas = [
  {
    vimeoId: '349948239',
    title: 'Multiply Whole Number by a Fraction',
    thumb: 'multiplying-whole-by-a-fraction-using-fraction-circles.png',
    manipulatives: ['fraction-circles'],
    keywords: ['multiply', 'multiplying', 'multiplication', 'product', 'whole', 'number', 'fraction', 'circles'],
    description: 'Visualize multiplying a whole number by a fraction.'
  },
  {
    vimeoId: '349893349',
    title: 'Adding Fractions',
    thumb: 'adding-fraction-with-unlike-denominators-using-fraction-tiles.png',
    manipulatives: ['fraction-tiles'],
    keywords: ['fractions', 'adding', 'addition', 'sum', 'summing', 'unlike', 'denominators', 'tiles', 'different'],
    description: 'Find equivalent fractions so that addends have the same size units.'
  },
  {
    vimeoId: '349857228',
    title: 'Slope Intercept Form',
    thumb: 'slope-intercept-form-using-cuisenaire-rods.png',
    manipulatives: ['cuisenaire-rods'],
    keywords: ['slope', 'intercept', 'cuisenaire', 'rods', 'graph', 'graphing', 'equations', 'formula', 'mx'],
    description: 'Derive the slope-intercept form by visualizing the variable and the constant.'
  },
  {
    vimeoId: '349962501',
    title: 'Multiply Fraction by a Whole Number',
    thumb: 'multiply-fraction-whole-number-using-fraction-tiles.png',
    manipulatives: ['fraction-tiles'],
    keywords: ['multiply', 'multiplying', 'multiplication', 'product', 'whole', 'number', 'fraction', 'tiles'],
    description: 'Visualize multiplying a fraction by a whole number.'
  },
  {
    vimeoId: '349941251',
    title: 'Common Multiples',
    thumb: 'common-multiples-using-linking-cubes.png',
    manipulatives: ['linking-cubes'],
    keywords: ['common', 'multiples', 'linking', 'cubes', 'connecting', 'unifix'],
    description: 'Find common multiples by listing multiples of each number and identifying those in common.'
  },
  {
    vimeoId: '349796591',
    title: 'Division with Unit Fractions',
    thumb: 'division-with-unit-fractions-using-fraction-tiles.png',
    manipulatives: ['fraction-tiles'],
    keywords: ['division', 'divide', 'dividing', 'units', 'fractions', 'tiles'],
    description: 'Divide a whole unit by different unit fractions and discover a multiplication pattern.'
  },
  {
    vimeoId: '349796368',
    title: '5 Ways to Multiply',
    thumb: 'five-ways-to-multiply-with-number-lines.png',
    manipulatives: ['number-lines', 'two-color-counters', 'base-ten-blocks', 'linking-cubes', 'fraction-tiles'],
    keywords: ['number', 'lines', 'multiply', 'multiplying', 'multiplication', 'products', 'two', 'color', 'counters', 'base', 'ten', 'linking', 'cubes', 'connecting', 'unifix', 'tens', 'frames', 'tiles'],
    description: 'It is better to solve 1 problem 5 different ways, than 5 different problems 1 way.'
  },
  {
    vimeoId: '349782287',
    title: 'Addition as Count and Measure',
    thumb: 'addition-as-count-and-measure-using-linking-cubes.png',
    manipulatives: ['linking-cubes'],
    keywords: ['add', 'adding', 'addition', 'sum', 'summing', 'linking', 'cubes', 'unifix', 'connecting', 'frames'],
    description: 'Model addiiton as both count (quantity) and measure (distance).'
  },
  {
    vimeoId: '349795644',
    title: 'Addition with Regrouping',
    thumb: 'addition-with-regrouping-using-base-ten-blocks.png',
    manipulatives: ['base-ten-blocks'],
    keywords: ['add', 'adding', 'addition', 'sum', 'summing', 'regroup', 'regrouping', 'group', 'two', 'digit', 'base', 'ten', 'base-10', 'base-ten', 'blocks'],
    description: 'Use base ten blocks and place value chart to add digits in each place and regroup if necessary.'
  },
  {
    vimeoId: '349793652',
    title: 'Area of a Circle',
    thumb: 'area-of-a-circle-using-fraction-circles.png',
    manipulatives: ['fraction-circles'],
    keywords: ['area', 'circles', 'formula', 'fraction', 'circles', 'derive'],
    description: 'Derive the formula for the area of a circle, from the formula for the area of a parallelogram.'
  },
  {
    vimeoId: '349792577',
    title: 'Bar Graph',
    thumb: 'bar-graph-using-color-tiles.png',
    manipulatives: ['color-tiles'],
    keywords: ['bar', 'graphs', 'color', 'tiles'],
    description: 'Create bar graphs and visualize problems asking "how many more" and "how many less".'
  },
  {
    vimeoId: '349754974',
    title: 'Comparing Multi-Digit Numbers',
    thumb: 'comparing-multi-digit-numbers-using-place-value-disks.png',
    manipulatives: ['place-value-disks'],
    keywords: ['compare', 'comparing', 'large', 'numbers', 'place', 'value', 'disks'],
    description: 'Compare numbers using a place value chart and comparing from greatest to least place value.'
  },
  {
    vimeoId: '349754219',
    title: 'Counting',
    thumb: 'counting-using-rekenrek.png',
    manipulatives: ['rekenreks'],
    keywords: ['count', 'counting', 'rekenreks', 'subitize', 'subitizing', 'make', 'making', '10', 'ten'],
    description: 'Anchoring thinking to 5s and 10s. Develop ability to subitize (instantly recognize quantities).'
  },
  {
    vimeoId: '349757598',
    title: 'Counting On and Back',
    thumb: 'counting-on-back-using-hundred-board.png',
    manipulatives: ['hundred-board'],
    keywords: ['count', 'counting', 'on', 'back', 'hundreds', 'board', 'chart'],
    description: 'Count forward and back by 1s to develop early addition and subtraction understanding.'
  },
  {
    vimeoId: '349748641',
    title: 'Distributive Property',
    thumb: 'distributive-property-using-algebra-tiles.png',
    manipulatives: ['algebra-tiles'],
    keywords: ['distributive', 'property', 'algebra', 'tiles'],
    description: 'Multiply a sum by multiplying each addend separately and then combining like terms.'
  },
  {
    vimeoId: '349752683',
    title: 'Division',
    thumb: 'division-using-color-tiles.png',
    manipulatives: ['color-tiles'],
    keywords: ['division', 'divide', 'dividing', 'color', 'tiles', 'repeated'],
    description: 'Visualizing division as “how many of divisor are in dividend” and as inverse of multiplication.'
  },
  {
    vimeoId: '349859606',
    title: 'Division with a Remainder',
    thumb: 'dividing-with-remainder-using-cuisenaire-rods.png',
    manipulatives: ['cuisenaire-rods'],
    keywords: ['division', 'divide', 'dividing', 'cuisenaire', 'rods', 'remainder', 'remain', 'left', 'over'],
    description: 'Find how many times the divisor goes into the dividend, with some amount left over.'
  },
  {
    vimeoId: '349755274',
    title: 'Equivalent Fractions',
    thumb: 'equivalent-fractions-using-pattern-blocks.png',
    manipulatives: ['pattern-blocks'],
    keywords: ['equivalent', 'fractions', 'pattern', 'blocks'],
    description: 'Equivalent fractions have the same value but have different numerators and denominators.'
  },
  {
    vimeoId: '349776194',
    title: 'Equivalent Ratios',
    thumb: 'equivalent-ratios-using-cuisenaire-rods.png',
    manipulatives: ['cuisenaire-rods'],
    keywords: ['equivalent', 'ratios', 'cuisenaire', 'rods'],
    description: 'Equivalent ratios express the same relationship, but using different numbers.'
  },
  {
    vimeoId: '349791863',
    title: 'Estimating Area',
    thumb: 'estimating-area-using-color-tiles.png',
    manipulatives: ['color-tiles'],
    keywords: ['areas', 'estimate', 'estimating', 'color', 'tiles'],
    description: 'Estimate the area of a figure by counting the number of unit squares that fit inside.'
  },
  {
    vimeoId: '349795932',
    title: 'Finding Missing Numbers',
    thumb: 'finding-missing-numbers-using-hundred-board.png',
    manipulatives: ['hundred-board'],
    keywords: ['find', 'missing', 'numbers', 'add', 'adding', 'addition', 'place', 'value', 'hundreds', 'board', 'chart'],
    description: 'Count on and back by 1s and 10s to find missing values.'
  },
  {
    vimeoId: '349912875',
    title: 'Improper Fractions to Mixed Numbers',
    thumb: 'improper-fractions-to-mixed-numbers-using-pattern-blocks.png',
    manipulatives: ['pattern-blocks'],
    keywords: ['convert', 'converting', 'fractions', 'mixed', 'numbers', 'pattern', 'blocks'],
    description: 'Visualize converting a fraction to a mixed number.'
  },
  {
    vimeoId: '349795087',
    title: 'Isometric Drawings',
    thumb: 'isometric-drawing-using-geoboard.png',
    manipulatives: ['geoboard'],
    keywords: ['isometric', 'drawing', '3d', 'geoboard'],
    description: 'Make 3D shapes and relate to 2D projections of the front, side, and top views.'
  },
  {
    vimeoId: '349855721',
    title: 'Many Ways to Show 213',
    thumb: 'many-ways-to-show-213-using-base-ten-blocks.png',
    manipulatives: ['base-ten-blocks'],
    keywords: ['multiple', 'representations', 'base', 'ten', 'base-ten', 'base-10', 'place', 'value', 'blocks'],
    description: 'Show understanding of place value by representing the number 213 is different ways.'
  },
  {
    vimeoId: '349751215',
    title: 'Mixed Numbers',
    thumb: 'mixed-numbers-using-fraction-circles.png',
    manipulatives: ['fraction-circles'],
    keywords: ['mixed', 'numbers', 'improper', 'fraction', 'circles'],
    description: 'Understand mixed numbers and see how they relate to improper fractions.'
  },
  {
    vimeoId: '349792812',
    title: 'Multiplication Models',
    thumb: 'multiplication-models-using-cuisenaire-rods.png',
    manipulatives: ['cuisenaire-rods'],
    keywords: ['multiply', 'multiplying', 'multiplication', 'product', 'cuisenaire', 'rods', 'arrays'],
    description: 'Explore the progression of multiplication from (1) repeated addition, to (2) arrays, to (3) area.'
  },
  {
    vimeoId: '349893798',
    title: 'Multiplying by Multiple of 10',
    thumb: 'multiply-by-tens-using-base-ten-blocks.png',
    manipulatives: ['base-ten-blocks'],
    keywords: ['multiply', 'multiplying', 'multiplication', 'product', '10', 'ten', 'base', 'ten', 'base-ten', 'base-10', 'blocks'],
    description: 'Multiply a one-digit whole numbers by multiples of 10 using place value and operations.'
  },
  {
    vimeoId: '349753131',
    title: 'Multiplying Integers',
    thumb: 'multiplying-integers-using-algebra-tiles.png',
    manipulatives: ['algebra-tiles'],
    keywords: ['multiply', 'multiplying', 'multiplication', 'product', 'integers', 'sign', 'signed', 'numbers', 'positive', 'negative', 'algebra', 'tiles'],
    description: 'Reasoning (instead of just memorizing) whether the product of integers is positive or negative.'
  },
  {
    vimeoId: '349755568',
    title: 'Multiplying Whole Numbers',
    thumb: 'multiplying-whole-numbers-using-number-line.png',
    manipulatives: ['number-lines'],
    keywords: ['multiply', 'multiplying', 'multiplication', 'product', 'whole', 'numbers', 'commutative', 'property', 'number', 'lines'],
    description: 'Multiplication with hops on the number line, then reversing factors to discover commutativity.'
  },
  {
    vimeoId: '349745720',
    title: 'Open Number Line Addition',
    thumb: 'addition-with-open-number-line-using-number-line.png',
    manipulatives: ['number-lines'],
    keywords: ['number', 'lines', 'open', 'add', 'addition', 'strategy', 'strategies'],
    description: 'Develop mental math strategies and explore multiple different solutions to a problem.'
  },
  {
    vimeoId: '349757891',
    title: 'Partitioning Rectangles',
    thumb: 'partitioning-rectangles-using-geoboard.png',
    manipulatives: ['geoboard'],
    keywords: ['partition', 'partitioning', 'area', 'rectangles', 'divide', 'dividing', 'geoboards'],
    description: 'Create equal size rows and columns to start understanding the rectangle multiplication model.'
  },
  {
    vimeoId: '349792417',
    title: 'Pattern Blocks in Base-10',
    thumb: 'pattern-blocks-in-base-ten-pattern-blocks.png',
    manipulatives: ['pattern-blocks'],
    keywords: ['pattern', 'blocks', 'base', 'ten', '10', 'base-10', 'base-ten'],
    description: 'Use deci extentions to pattern blocks to model all the numbers 1 through 10.'
  },
  {
    vimeoId: '349859080',
    title: 'Prime and Composite Numbers',
    thumb: 'prime-and-composite-using-color-tiles.png',
    manipulatives: ['color-tiles'],
    keywords: ['prime', 'composite', 'numbers', 'color', 'tiles', 'factors'],
    description: 'The only factors of a prime are 1 and itself. So the only rectangle it can make is a single row.'
  },
  {
    vimeoId: '349745029',
    title: 'Proportions',
    thumb: 'proportions-using-cuisenaire-rods.png',
    manipulatives: ['cuisenaire-rods'],
    keywords: ['proportions', 'proportional', 'ratios', 'cuisenaire', 'rods'],
    description: 'Use multiplicative relationships to compare quantities and to predict a value.'
  },
  {
    vimeoId: '349776574',
    title: 'Simplifying Expressions',
    thumb: 'simplifying-expressions-using-algebra-tiles.png',
    manipulatives: ['algebra-tiles'],
    keywords: ['simplify', 'simplifying', 'expressions', 'like', 'terms', 'algebra', 'tiles'],
    description: 'Simplify expressions by combining like terms and making zero pairs.'
  },
  {
    vimeoId: '349750893',
    title: 'Skip Counting',
    thumb: 'skip-counting-using-hundred-board.png',
    manipulatives: ['hundred-board'],
    keywords: ['skip', 'counting', 'by', 'hundreds', 'boards', 'charts'],
    description: 'Count forward by numbers other than 1 to develop multiplication patterns and skills.'
  },
  {
    vimeoId: '349758467',
    title: 'Skip Counting',
    thumb: 'skip-counting-using-cuisenaire-rods.png',
    manipulatives: ['cuisenaire-rods'],
    keywords: ['skip', 'counting', 'by', 'cuisenaire', 'rods'],
    description: 'Count forward by numbers other than 1 to develop multiplication patterns and skills.'
  },
  {
    vimeoId: '349751725',
    title: 'Subtracting',
    thumb: 'subtracting-using-cuisenaire-rods.png',
    manipulatives: ['cuisenaire-rods'],
    keywords: ['slope', 'intercept', 'cuisenaire', 'rods', 'graph', 'graphing', 'equations', 'formula', 'mx'],
    description: 'Use bar and distance models to show subtraction as the difference between two numbers.'
  },
  {
    vimeoId: '349756659',
    title: 'Subtracting',
    thumb: 'subtraction-using-linking-cubes.png',
    manipulatives: ['linking-cubes'],
    keywords: ['subtract', 'subtracting', 'subtraction', 'difference', 'compare', 'linking', 'cubes', 'unifix', 'connecting'],
    description: 'Modeling subtraction as (1) take-away, (2) comparison, (3) missing addend.'
  },
  {
    vimeoId: '349758255',
    title: 'Subtracting',
    thumb: 'subtraction-using-color-tiles.png',
    manipulatives: ['color-tiles'],
    keywords: ['subtract', 'subtracting', 'subtraction', 'difference', 'compare', 'color', 'tiles'],
    description: 'Visualize subtraction using a part-part-whole model, and relating subtraction to division.'
  },
  {
    vimeoId: '349792036',
    title: 'Subtraction Strategies',
    thumb: 'subtraction-strategies-using-two-color-counters.png',
    manipulatives: ['two-color-counters'],
    keywords: ['subtract', 'subtracting', 'subtraction', 'difference', 'compare', 'strategy', 'strategies', 'tens', 'frames', 'two', 'color', 'counters', 'missing', 'take', 'away'],
    description: 'Modeling subtraction as (1) take-away, (2) comparison, (3) missing addend.'
  },
  {
    vimeoId: '349792698',
    title: 'Subtraction Strategy',
    thumb: 'subtraction-strategy-using-number-lines.png',
    manipulatives: ['number-lines'],
    keywords: ['subtract', 'subtracting', 'subtraction', 'difference', 'compare', 'strategy', 'strategies', 'number', 'line'],
    description: 'Subtract using the Constant Difference strategy and shifting to a friendly number.'
  },
  {
    vimeoId: '349796220',
    title: 'Tens Frames Addition',
    thumb: 'tens-frames-addition-using-two-color-counters.png',
    manipulatives: ['two-color-counters'],
    keywords: ['add', 'adding', 'addition', 'sum', 'summing', 'tens', 'frames', 'make', 'making', '10', 'ten', 'two', 'color', 'counters'],
    description: 'Explore some addition strategies: (1) make a ten, (2) make a double, (2) make 20 and subtract.'
  },
  {
    vimeoId: '349758641',
    title: 'Understanding Fractions',
    thumb: 'understanding-fractions-using-fraction-circles.png',
    manipulatives: ['fraction-circles'],
    keywords: ['fractions', 'parts', 'wholes', 'fraction', 'circles'],
    description: 'Model fractions as equal parts of a whole and understand the numerator and denominator.'
  },
  {
    vimeoId: '349795808',
    title: 'Ways to Make a Number',
    thumb: 'many-ways-to-make-a-number-using-two-color-counters.png',
    manipulatives: ['two-color-counters'],
    keywords: ['number', 'make', 'represent', 'two', 'color', 'counters', 'understand', 'understanding'],
    description: 'Discover and visualize how numbers are made from other numbers.'
  },
  {
    vimeoId: '349796050',
    title: 'What is In a Number',
    thumb: 'whats-in-a-number-using-cuisenaire-rods.png',
    manipulatives: ['cuisenaire-rods'],
    keywords: ['number', 'compose', 'composition', 'make', 'cuisenaire', 'rods'],
    description: 'Discover how a number can be made by combining other numbers.'
  },
  {
    vimeoId: '349925162',
    title: 'Multiplication',
    thumb: 'multiplication-using-color-tiles.png',
    manipulatives: ['color-tiles'],
    keywords: ['multiply', 'multiplying', 'multiplication', 'product', 'color', 'tiles', 'repeate', 'addition', 'array'],
    description: 'Evolution of multiplication from repeated addition and equal groups to arrays and area.'
  },
  {
    vimeoId: '349926890',
    title: 'Adding 3 Numbers',
    thumb: 'adding-three-numbers-using-linking-cubes.png',
    manipulatives: ['linking-cubes'],
    keywords: ['add', 'adding', 'addition', '3', 'three', 'linking', 'cubes', 'unifix', 'connecting'],
    description: 'Adding 3 numbers using multiple different models.'
  },
  {
    vimeoId: '349954998',
    title: 'Dot Cards',
    thumb: 'dot-cards-using-two-color-counters.png',
    manipulatives: ['two-color-counters'],
    keywords: ['dot', 'cards', 'subitize', 'recognize', 'numbers', 'two', 'color', 'counters'],
    description: 'Develop subitizing skills to instantly recognize quantities. Many ways to visualize quantities.'
  },
  {
    vimeoId: '349960891',
    title: 'Factors of a Number',
    thumb: 'factors-of-a-number-using-cuisenaire-rods.png',
    manipulatives: ['cuisenaire-rods'],
    keywords: ['factors', 'number', 'multiples', 'cuisenaire', 'rods'],
    description: 'Visually identify pairs of numbers that multiply to make a number.'
  },
  {
    vimeoId: '349971214',
    title: 'Understanding Place Value',
    thumb: 'understanding-place-value-using-base-ten-blocks.png',
    manipulatives: ['base-ten-blocks'],
    keywords: ['place', 'value', 'large', 'numbers', 'base', 'ten', 'blocks'],
    description: 'Demonstrate place value and see why it is valuable for large numbers.'
  },
  {
    vimeoId: '349973606',
    title: 'Subtracting Integers',
    thumb: 'subtracting-integers-using-two-color-counters.png',
    manipulatives: ['two-color-counters'],
    keywords: ['subtract', 'subtracting', 'subtraction', 'difference', 'compare', 'take', 'taking', 'away'],
    description: 'Subtraction can be thought of as removing or taking away. Model subtracting a negative. '
  }
]

export default ideas
